import { createAction, props } from '@ngrx/store';

import {
  ChargerOperationalStatusStoreModelEnum,
  SiteAlertStateStoreModelEnum,
  SitesSortByStoreModelEnum,
  SitesViewModeStoreModelEnum,
} from '@domain/sites/sites.enums';
import { SiteStatsStoreModel } from '@domain/sites/sites.models';

import { SortDirectionStoreModelEnum } from '@shared/enums/sort-direction.enum';

import { SitesFilterChangeEvent } from '../components/sites-filter/sites-filter.view-model';
import { SitesTableSortPropertyStoreModelEnum } from '../enums/sites-table-sort-property.enum';

export const loadSites = createAction('[Sites] load sites', props<{ polling: boolean }>());
export const loadSitesSuccess = createAction('[Sites] load sites success', props<{ sites: SiteStatsStoreModel[]; polling: boolean }>());
export const loadSitesFailure = createAction('[Sites] load sites failure', props<{ error: string }>());
export const detailedListOfSitesSocketMessageArrive = createAction(
  '[Sites] detailed list of sites socket message arrive',
  props<{ sites: SiteStatsStoreModel[] }>()
);

export const setSitesFilters = createAction('[Sites] set sites filters', props<{ filters: SitesFilterChangeEvent }>());
export const setMobileSitesSearch = createAction('[Sites] set mobile sites search', props<{ search: string }>());
export const setMobileSitesTenants = createAction('[Sites] set mobile sites tenants', props<{ tenants: string[] }>());
export const validateMobileSitesTenants = createAction('[Sites] validate mobile sites tenants', props<{ availableTenants: string[] }>());
export const setSitesSortBy = createAction('[Sites] set sites sort by', props<{ sortBy: SitesSortByStoreModelEnum }>());
export const toggleSiteCollapsed = createAction('[Sites] toggle site collapsed', props<{ siteId: string }>());
export const setSitesViewMode = createAction('[Sites] set sites view mode', props<{ viewMode: SitesViewModeStoreModelEnum }>());
export const setSitesTableSort = createAction(
  '[Sites] set sites table sort',
  props<{ sortProperty: SitesTableSortPropertyStoreModelEnum; sortDirection: SortDirectionStoreModelEnum }>()
);
export const toggleMapCollapsed = createAction('[Sites] toggle map collapsed');

export const setSelectedSiteId = createAction('[Sites] set selected site id', props<{ siteId: string | null }>());

export const applyStatusFilterFromMap = createAction(
  '[Sites] apply status filter from map',
  props<{ status: SiteAlertStateStoreModelEnum }>()
);
export const applyChargerStateFilterFromMap = createAction(
  '[Sites] apply charger state filter from map',
  props<{ chargerState: ChargerOperationalStatusStoreModelEnum }>()
);

export const clearSites = createAction('[Sites] clear sites');
